<template>
  <div class="container-new-tab_fix m-9">
    <div class="content flex-column">
      <div class="w-100">
        <h1>{{ $t("tabs.newTab") }}</h1>
        <h2>{{ $t("tabs.openBookMsg") }}</h2>
      </div>

      <div v-if="!$_mobile" class="w-100 mrg-t-12">
        <h3>{{ $t("searchInput.placeHolder") }}</h3>
      </div>
      <div v-if="!$_mobile" class="flex flex-nowrap flex-center m-9 w-100">
        <inputSearchBook
          style="padding-right: 3px; width: 400px"
          @searchResults="setSearchResults"
        />
      </div>

      <div
        v-if="!$_mobile"
        class="flex flex-nowrap flex-center m-9 w-100 mrg-t-12"
      >
        <div
          v-if="showPrevArrow"
          @click="prevImages"
          class="arrow-scroll arrow-right"
          v-tooltip="$t('tabs.prevSearchResults')"
        >
          <div class="icon">M</div>
        </div>
        <newTabBookItem
          v-for="(book, i) in visibleSearchResults"
          :key="book.id + '_' + i"
          :book="book.id"
          :id="book.id"
          :allowDelete="false"
        />
        <div
          v-if="showNextArrow"
          @click="nextImages"
          class="arrow-scroll arrow-left"
          v-tooltip="$t('tabs.nextSearchResults')"
        >
          <div class="icon">M</div>
        </div>
      </div>

      <div class="w-100 mrg-t-12">
        <h3 v-if="recentBooksList.length > 0" v-kiosk.remove>
          {{ $t("userDefaultFolders.recentbooks") }}
        </h3>
      </div>
      <div
        class="flex flex-center m-9 w-100"
        :class="{
          'flex-nowrap': favoriteBooksCount > 0,
          'flex-wrap': favoriteBooksCount == 0,
        }"
        :style="{ maxWidth: maxContainerWidth }"
      >
        <newTabBookItem
          v-for="(book, i) in recentBooksList"
          :key="book.bookId + '_' + i"
          :book="book.bookId"
          :id="book.id"
          :allowDelete="true"
        />
      </div>
      <div class="w-100 mrg-t-12">
        <h3 v-if="favoriteBooksCount > 0">{{ $t("wellcome1.text17") }}</h3>
      </div>
      <div class="flex flex-nowrap flex-center m-9 w-100">
        <newTabBookItem
          v-for="(book, i) in favoriteBooksList"
          :key="book.id + '_' + i"
          :book="book.id"
          :id="book.id"
          :allowDelete="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import newTabBookItem from "@/components/book/newTabBookItem.vue";
import inputSearchBook from "@/components/book/inputSearchBook.vue";
import { books, treeBooks } from "@/store/modules/books";
export default {
  props: ["book", "page"],

  components: { newTabBookItem, inputSearchBook },
  data() {
    return {
      favoriteBooksCount: 0,
      maxFavorites: 5,
      maxRecent: 5,
      searchResults: [],
      currentResultsIndex: 0, // To track the starting image index
      imagesPerPage: 5, // Number of images to show at a time
    };
  },
  computed: {
    ...mapGetters("userRecentBooks", ["getRecentBooks"]),
    ...mapGetters("userFavoriteBooks", ["getFavoriteBooks"]),
    showPrevArrow() {
      return this.searchResults.length && this.currentResultsIndex > 0;
    },
    showNextArrow() {
      return (
        this.searchResults.length &&
        this.currentResultsIndex <
          this.searchResults.length - this.imagesPerPage
      );
    },
    visibleSearchResults() {
      // Get the images for the current "page"
      return this.searchResults.slice(
        this.currentResultsIndex,
        this.currentResultsIndex + this.imagesPerPage
      );
    },
    maxContainerWidth() {
      return Math.round(this.userSettings.settings.widthBook) + "px";
    },
    recentBooksList() {
      let list = (this.getRecentBooks || [])
        .slice(
          0,
          this.favoriteBooksCount === 0
            ? this.maxBooksToShow + this.maxBooksToShow
            : this.maxBooksToShow
        )
        .filter((b) => {
          let book = this.$store.getters["books/getBookbyId"](b.bookId);
          if (book) return true;
        });

      return list;
    },
    favoriteBooksList() {
      let favBooks = [];

      for (
        var i = 0;
        i < books.length && favBooks.length < this.maxBooksToShow;
        i++
      ) {
        let b = treeBooks.get(treeBooks.root, books[i].id);
        if (b && b.favorite) {
          let book = this.$store.getters["books/getBookbyId"](b.id);
          if (book) favBooks.push(book);
        }
      }
      this.favoriteBooksCount = favBooks.length;
      return favBooks;
    },
    maxBooksToShow() {
      return this.userSettings.settings.widthBook
        ? Math.round(
            ((this.userSettings.settings.widthBook / 100) * 80) / 130
          ) - 2
        : 5;
    },
  },
  methods: {
    nextImages() {
      if (
        this.currentResultsIndex + this.imagesPerPage <
        this.searchResults.length
      ) {
        this.currentResultsIndex += this.imagesPerPage;
      }
    },
    prevImages() {
      if (this.currentResultsIndex > 0) {
        this.currentResultsIndex -= this.imagesPerPage;
      }
    },
    setSearchResults(res) {
      this.searchResults = res;
    },
  },
  created() {
    this.$nextTick(() => {
      if (!this.$store.state.bookList.fromKeyboard)
        this.$store.state.bookList.setFocusInInput++;

      this.$store.state.bookList.fromKeyboard = false;
    });
  },
};
</script>
<style lang="scss" scoped>
.container-new-tab_fix {
  width: 100%;
  height: 100%;
  overflow: auto;
  input {
    border: 1px solid rgba(0, 0, 0, 0.2) !important;
  }
  h1,
  h2,
  h3 {
    text-align: right;
    margin: 0;
  }
  h1 {
    font-size: 21px;
  }
  h2 {
    margin-bottom: 15px;
    font-size: 17px;
    font-weight: normal;
  }
  h3 {
    color: var(--custom-color1);
    margin-bottom: 10px;
  }
  .content {
    margin-top: 30px !important;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: fit-content;
    max-width: 80%;
    margin: auto;
  }
}
.container-new-tab {
  width: 100%;
  h1,
  h2,
  h3 {
    text-align: right;
    margin: 0;
  }
  h1 {
    font-size: 21px;
  }
  h2 {
    margin-bottom: 15px;
    font-size: 17px;
    font-weight: normal;
  }
  h3 {
    color: var(--custom-color1);
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: fit-content;
    max-width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    margin: auto;
    .item {
      flex-basis: 33%;
    }
  }
}

.slider-container {
  display: flex;
  align-items: center;
}

.slider {
  overflow: hidden;
  width: 1000px; /* Adjust to your needs */
  margin: 0 10px;
}

.image-track {
  display: flex;
  transition: transform 0.5s ease;
}

.image {
  flex: 0 0 20%; /* Adjust this to fit 5 images in the container (5 * 20% = 100%) */
  display: flex;
  justify-content: center;
}
.arrow-scroll {
  position: relative;
  font-family: otzar-new;
  font-size: 30px;
  color: #000000;
  margin-top: 7px;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  .icon {
    font-family: otzar-new;
    font-size: 30px;
    color: #000000;
    transform: rotate(-90deg);
  }
  &.arrow-right {
    // transform: translateY(-50%);
    left: auto;
    // transform-origin: right;
  }
  &.arrow-left {
    // transform: translateY(-50%);
    // transform-origin: left;
    .icon {
      transform: rotate(90deg);
    }
  }
}

.image img {
  max-width: 100%;
  height: auto;
}

.nav-button {
  background-color: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.nav-button.left {
  margin-right: 10px;
}

.nav-button.right {
  margin-left: 10px;
}
</style>
